import React from "react";
import { SearchIcon } from "../../assets/svgs/Icons";
import {
    Box,
    Flex,
    Input,
    InputGroup,
    InputLeftElement,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Tfoot,
    Th,
    Thead,
    Tr,
  } from "@chakra-ui/react";
import { Link } from "react-router-dom";

export const IncomingShipmentList = () => {
    return (
        <Box paddingTop={"3.5rem"}>
          <Flex gap={"10"} alignItems={"center"}>
            <Box>
              {" "}
              <Text
                color="brand.blue"
                fontSize="28px"
                fontWeight={"600"}
               
              >
              Incoming Shipments
              </Text>
              <Text color="brand.royalBlue" fontSize="sm">
              {"Checkout from where it’s coming"}
              </Text>
            </Box>
            <Box>
              <InputGroup>
                <InputLeftElement
                  pointerEvents="none"
                  children={<SearchIcon w="28" h="28" color="brand.lightBlue" />}
                />
                <Input
                  type="tel"
                  color="brand.lightBlue"
                  bg="brand.white"
                  w={"276px"}
                  h={"48px"}
                  placeholder="Search"
                  fontSize={"14px"}
                  borderRadius={"10px"}
                  _placeholder={{
                    opacity: 1,
                    color: "brand.lightBlue",
                    fontSize: "14px",
                  }}
                />
              </InputGroup>
            </Box>
          </Flex>
          <Box marginTop={"2rem"}>
            <TableContainer>
              <Table size="lg" bg="brand.white" borderRadius="15px">
                <Thead fontStyle={"normal"}>
                  <Tr fontStyle={"normal"}>
                    <Th color="brand.blue" textTransform="capitalize">Sr No.</Th>
                    <Th color="brand.blue" textTransform="capitalize">Date</Th>
                    <Th color="brand.blue" textTransform="capitalize">Seller Name</Th>
                    <Th color="brand.blue" textTransform="capitalize">Company ID</Th>
                    <Th color="brand.blue" textTransform="capitalize">Product</Th>
                    <Th color="brand.blue" textTransform="capitalize">Quantity</Th>
                    <Th color="brand.blue" textTransform="capitalize">Unit #</Th>
                    <Th color="brand.blue" textTransform="capitalize">Actions</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>1</Td>
                    <Td>1/1/2023</Td>
                    <Td>Dean Dayal</Td>
                    <Td>SP0012134</Td>
                    <Td>Organic Cotton</Td>
                    <Td>100 Kg</Td>
                    <Td>003</Td>
                    <Td color="brand.royalBlue" fontWeight={"700"}>
                        <Link to={"./shipment-details"}>View Details</Link>
                     
                    </Td>
                  </Tr>

                  <Tr>
                    <Td>2</Td>
                    <Td>1/1/2023</Td>
                    <Td>Dean Dayal</Td>
                    <Td>SP0012134</Td>
                    <Td>Organic Cotton</Td>
                    <Td>100 Kg</Td>
                    <Td>003</Td>
                    <Td color="brand.royalBlue" fontWeight={"700"}>
                     View Details
                    </Td>
                  </Tr>

                  <Tr>
                    <Td>3</Td>
                    <Td>1/1/2023</Td>
                    <Td>Dean Dayal</Td>
                    <Td>SP0012134</Td>
                    <Td>Organic Cotton</Td>
                    <Td>100 Kg</Td>
                    <Td>003</Td>
                    <Td color="brand.royalBlue" fontWeight={"700"}>
                     View Details
                    </Td>
                  </Tr>

                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      );
}